import { useEffect, useRef, useState } from 'react';
import SideBarMobile from "../../../../components/sideBarMobile";
import DropDownMenuHeader from '../../../../components/dropDownMenuHeader';
import BreadCrumbs from '../../../../components/breadCrumbs';
import { useSelector } from 'react-redux';
import './index.css';

function HeaderDashboard(){
  const account = useSelector((state) => state.account.account);

  const [isShowSideBarMobile, setIsShowSideBarMobile] = useState(false);
  const [openDropDown, setOpenDropDown] = useState(false);
  const breadCrumbs_dashboard=[
    {name: 'Trang chủ'}
  ];

  const ref = useRef(null);

  useEffect(() => {
      
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        setOpenDropDown(false);
      }
    }
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [ref]);

  return (
    <>
      <div className="header_container w-100">
        <div className="header">
          <div className="header_left">
            <div className="display_header"><BreadCrumbs arr_breadcrumbs={breadCrumbs_dashboard}></BreadCrumbs></div>
              <button className="btn-open-nav-mobile"><i className="fa fa-bars"  onClick={() => setIsShowSideBarMobile(true)}></i></button>
            </div>
            <div className="name_mobile">
              <h1>ISTORAGE</h1>
            </div>
            <div className="header_right" ref={ref}>
              <button className="noti_header">
                <img className="noti_img" src="./dashboard/notifications.svg" alt="" />
                {/* <img className="ellipse" src="./dashboard/Ellipse 21.svg" alt="" />
                <div className="quantity_noti">5</div> */}
              </button>
              <button className="avartar" onClick ={()=>setOpenDropDown(!openDropDown)}>
                <img src="./dashboard/Ellipse 26.png" alt="" />
              </button>
              <button className="account_name" onClick ={()=>setOpenDropDown(!openDropDown)}>{account.user.email.split('@')[0]} <img className="icon_dropdown" src="./dashboard/icon_dropdown.png" alt="" /></button>
                {openDropDown && 
                  <DropDownMenuHeader></DropDownMenuHeader>
                }
            </div>
          </div>
      </div>
      {isShowSideBarMobile &&
      <>
        <div className="overlay" onClick={() => setIsShowSideBarMobile(false)}></div>
        <div className="sidebar_mobile">
          <SideBarMobile activeIndex={1} onClose={() => setIsShowSideBarMobile(false)}></SideBarMobile>
        </div>
      </>
      }
    </>
  );
}
export default HeaderDashboard;